import {
  FullscreenOverlayContainer,
  OverlayContainer,
} from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import {
  ContextMenuModule,
  ContextMenuService,
} from '@perfectmemory/ngx-contextmenu';
import { AngularOpenlayersModule } from 'ng-openlayers';
import { GkComponentsModule } from '../gk-components/gk-components.module';
import { GkDynamicFormModule } from '../gk-dynamic-form/gk-dynamic-form.module';
import { GkDynamicListModule } from '../gk-dynamic-list/gk-dynamic-list.module';
import { GkKendoModule } from '../gk-kendo';
import { MapSettingsService } from '../services/map-settings/map-settings.service';
import {
  AttributesDynamicListComponent,
  AttributesFormComponent,
  ClearButtonComponent,
  FileLoaderFormComponent,
  HelpControlComponent,
  IncreaseRangeByBufferButtonComponent,
  InfoContentComponent,
  LandDetailsGridComponent,
  LayersTreeButtonComponent,
  LayersTreeSidebarComponent,
  LineStringComponent,
  MapComponent,
  MapGeometryComponent,
  MapLandClassesGridComponent,
  MapObjectTableComponent,
  MapPopupComponent,
  MapSheetFormComponent,
  MapToolbarComponent,
  MapToolComponent,
  MapToolContainerComponent,
  MapTooltipComponent,
  MapViewComponent,
  PaperDropdownComponent,
  PointComponent,
  PolygonComponent,
  PopupControlComponent,
  RangeFromAllParcelsButtonComponent,
  RangeFromSelectedParcelsButtonComponent,
  ScaleDropdownComponent,
  TreeNodeComponent,
  WmsLayersComponent,
} from './components';
import { MapBuildingDetailsComponent } from './components/map/map-building-details/map-building-details.component';
import { MapLandDetailsDetailsComponent } from './components/map/map-land-details-wrapper/map-land-details-details/map-land-details-details.component';
import { MapLandDetailsWrapperComponent } from './components/map/map-land-details-wrapper/map-land-details-wrapper.component';
import { Bdot500DetailsDetailsComponent } from './components/map/map-object-info/bdot500-details-wrapper/bdot500-details-details/bdot500-details-details.component';
import { Bdot500DetailsGridComponent } from './components/map/map-object-info/bdot500-details-wrapper/bdot500-details-grid/bdot500-details-grid.component';
import { Bdot500DetailsWrapperComponent } from './components/map/map-object-info/bdot500-details-wrapper/bdot500-details-wrapper.component';
import { BuildingDetailsGridComponent } from './components/map/map-object-info/building-details-wrapper/building-details-grid/building-details-grid.component';
import { BuildingDetailsWrapperComponent } from './components/map/map-object-info/building-details-wrapper/building-details-wrapper.component';
import { DevelopmentPlanDetailsGridComponent } from './components/map/map-object-info/development-plan-details/development-plan-details-grid/development-plan-details-grid.component';
import {
  MapAddressPointDetailsDetailsComponent,
  MapAddressPointDetailsGridComponent,
  MapAddressPointDetailsWrapperComponent,
} from './components/map/map-object-info/map-address-point-details-wrapper';
import { MatrixDetailsDetailsComponent } from './components/map/map-object-info/matrix-details-wrapper/matrix-details-details/matrix-details-details.component';
import { MatrixDetailsGridComponent } from './components/map/map-object-info/matrix-details-wrapper/matrix-details-grid/matrix-details-grid.component';
import { MatrixDetailsWrapperComponent } from './components/map/map-object-info/matrix-details-wrapper/matrix-details-wrapper.component';
import { StreetAxisDetailsDetailsComponent } from './components/map/map-object-info/street-axis-details-wrapper/street-axis-details-details/street-axis-details-details.component';
import { StreetAxisDetailsGridComponent } from './components/map/map-object-info/street-axis-details-wrapper/street-axis-details-grid/street-axis-details-grid.component';
import { StreetAxisDetailsWrapperComponent } from './components/map/map-object-info/street-axis-details-wrapper/street-axis-details-wrapper.component';
import { DownloadRangeModalComponent } from './components/map/map-toolbar/download-range-modal/download-range-modal.component';
import { MapMeasurementResultComponent } from './components/map/map-view/map-measurement-result/map-measurement-result.component';
import { MapMousePositionComponent } from './components/map/map-view/map-mouse-position/map-mouse-position.component';
import { MapPinControlComponent } from './components/map/map-view/map-pin-control/map-pin-control.component';
import { ElementFocusDirective } from './directives';
import { MapStateService } from './services';
import { MapDrawingActionService } from './services/map-drawing-action/map-drawing-action.service';
import { ModalAttachWmsComponent } from './components/map/map-view/modal-attach-wms/modal-attach-wms.component';
import { FreeServicesParcelDetailsComponent } from '../kendo-request-list/free-services-parcel-details/free-services-parcel-details.component';
import { FreeServicesParcelRequestGridComponent } from '../kendo-request-list/free-services-parcel-request-grid/fsp-parcel-request-grid/free-services-parcel-request-grid.component';
import { FreeServicesParcelSearchFormComponent } from '../kendo-request-list/free-services-parcel-request-grid/fsp-parcel-search-form/fsp-parcel-search-form.component';
import { FreeServicesRequestDetailsComponent } from '../kendo-request-list/free-services-request-details/free-services-request-details.component';
import { FreeServicesRequestListComponent } from '../kendo-request-list/free-services-request-list.component';
import { FreeServicesRequestListGridComponent } from '../kendo-request-list/free-services-request-list-grid/free-services-request-list-grid.component';
import { FreeServicesRequestSearchFormComponent } from '../kendo-request-list/free-services-request-search-form/free-services-request-search-form.component';
import { FspBorderPointsGridComponent } from '../kendo-request-list/free-services-parcel-request-grid/fsp-border-points-grid/fsp-border-points-grid.component';
import { FspBuildingRegisterComponent } from '../kendo-request-list/free-services-parcel-request-grid/fsp-building-register/fsp-building-register.component';
import { FspBuildingsDocsGridComponent } from '../kendo-request-list/free-services-parcel-request-grid/fsp-building-register/fsp-buildings-docs/fsp-buildings-docs-grid.component';
import { FspSubjectRequestGridComponent } from '../kendo-request-list/free-services-subject-request-grid/fsp-subject-request-grid.component';
import { FSPRequestDocumentGridComponent } from '../kendo-request-list/free-services-request-document-grid/request-document-grid.component';
import { FspPremissesRegisterComponent } from '../kendo-request-list/free-services-parcel-request-grid/fsp-premisses-register-grid/fsp-premisses-register.component';
import { FspPremissesOwnerGridComponent } from '../kendo-request-list/free-services-parcel-request-grid/fsp-premisses-register-grid/fsp-premisses-owners/fsp-premisses-owner-grid.component';
import { FspPremissesGridComponent } from '../kendo-request-list/free-services-parcel-request-grid/fsp-premisses-register-grid/fsp-premisses-grid/fsp-premisses-grid.component';
import { FspPremissesDocsGridComponent } from '../kendo-request-list/free-services-parcel-request-grid/fsp-premisses-register-grid/fsp-premisses-docs/fsp-premisses-docs-grid.component';
import { FspParcelsComponent } from '../kendo-request-list/free-services-parcel-request-grid/fsp-parcels.component';
import { FspOwnersGridComponent } from '../kendo-request-list/free-services-parcel-request-grid/fsp-owners-grid/fsp-owners-grid.component';
import { FspDocumentsGridComponent } from '../kendo-request-list/free-services-documents-grid/fsp-documents-grid.component';
import { FspClassUseGridComponent } from '../kendo-request-list/free-services-parcel-request-grid/fsp-class-use-grid/fsp-class-use-grid.component';
import { FspBuildingsOwnerGridComponent } from '../kendo-request-list/free-services-parcel-request-grid/fsp-building-register/fsp-building-owners/fsp-buildings-owner-grid.component';
import { FspBuildingsGridComponent } from '../kendo-request-list/free-services-parcel-request-grid/fsp-building-register/fsp-buildings-register-grid/fsp-buildings-grid.component';

const components = [
  MapComponent,
  MapViewComponent,
  MapToolbarComponent,
  ScaleDropdownComponent,
  MapTooltipComponent,
  MapGeometryComponent,
  PaperDropdownComponent,
  MapToolbarComponent,
  TreeNodeComponent,
  LayersTreeButtonComponent,
  LayersTreeSidebarComponent,
  WmsLayersComponent,
  MapToolComponent,
  HelpControlComponent,
  AttributesFormComponent,
  MapObjectTableComponent,
  FileLoaderFormComponent,
  MapSheetFormComponent,
  MapToolContainerComponent,
  MapPopupComponent,
  InfoContentComponent,
  AttributesDynamicListComponent,
  PopupControlComponent,
  PointComponent,
  LineStringComponent,
  PolygonComponent,
  ClearButtonComponent,
  RangeFromSelectedParcelsButtonComponent,
  RangeFromAllParcelsButtonComponent,
  IncreaseRangeByBufferButtonComponent,
  DownloadRangeModalComponent,
  MapMeasurementResultComponent,
  LandDetailsGridComponent,
  MapLandClassesGridComponent,
  MapBuildingDetailsComponent,
  MapLandDetailsWrapperComponent,
  MapLandDetailsDetailsComponent,
  MapPinControlComponent,
  MapMousePositionComponent,
  MapAddressPointDetailsWrapperComponent,
  MapAddressPointDetailsGridComponent,
  MapAddressPointDetailsDetailsComponent,
  MatrixDetailsWrapperComponent,
  MatrixDetailsGridComponent,
  MatrixDetailsDetailsComponent,
  Bdot500DetailsWrapperComponent,
  Bdot500DetailsGridComponent,
  Bdot500DetailsDetailsComponent,
  Bdot500DetailsWrapperComponent,
  StreetAxisDetailsWrapperComponent,
  StreetAxisDetailsGridComponent,
  StreetAxisDetailsDetailsComponent,
  DevelopmentPlanDetailsGridComponent,
  BuildingDetailsWrapperComponent,
  BuildingDetailsGridComponent,
  ModalAttachWmsComponent,
  FreeServicesParcelDetailsComponent,
  FreeServicesParcelRequestGridComponent,
  FreeServicesParcelSearchFormComponent,
  FreeServicesRequestDetailsComponent,
  FreeServicesRequestListComponent,
  FreeServicesRequestListGridComponent,
  FreeServicesRequestSearchFormComponent,
  FspBorderPointsGridComponent,
  FspBuildingRegisterComponent,
  FspBuildingsDocsGridComponent,
  FspBuildingsGridComponent,
  FspBuildingsOwnerGridComponent,
  FspClassUseGridComponent,
  FspDocumentsGridComponent,
  FspOwnersGridComponent,
  FspParcelsComponent,
  FspPremissesDocsGridComponent,
  FspPremissesGridComponent,
  FspPremissesOwnerGridComponent,
  FspPremissesRegisterComponent,
  FSPRequestDocumentGridComponent,
  FspSubjectRequestGridComponent,
];

const directives = [ElementFocusDirective];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    AngularOpenlayersModule,
    TranslateModule,
    ReactiveFormsModule,
    GkDynamicFormModule,
    GkDynamicListModule,
    ContextMenuModule,
    GkComponentsModule,
    GkKendoModule,
  ],
  declarations: [...components, ...directives],
  exports: [...components, ...directives],
  providers: [
    ContextMenuService,
    MapSettingsService,
    MapStateService,
    MapDrawingActionService,
    { provide: OverlayContainer, useClass: FullscreenOverlayContainer },
  ],
})
export class GkMapModule {}
